import { render, staticRenderFns } from "./backToTop.vue?vue&type=template&id=167b3717&scoped=true"
import script from "./backToTop.vue?vue&type=script&lang=js"
export * from "./backToTop.vue?vue&type=script&lang=js"
import style0 from "./backToTop.vue?vue&type=style&index=0&id=167b3717&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b3717",
  null
  
)

export default component.exports